import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Link } from "react-router-dom";
import { styles } from "../TracksPageComponents/styles";
import { useContext } from "react";
import {
  UserDetailsContext,
  UserDetailsContextInterface,
} from "../../contexts";
import { photo } from "../SingleProject/types";
import { ENTERPRISE_IMAGE_PATH, isEnterprise } from "../../theme";
import logo from "../ResponsiveNavbar/logo.png";
import { DrawerLogosProps } from "./types";

export const DrawerLogos: React.FC<DrawerLogosProps> = ({
  isDrawerOpen,
  setIsDrawerOpen,
  collapsed,
  onToggleCollapsed,
}) => {
  const { isEnterpriseAccount, enterprise } =
    useContext<UserDetailsContextInterface>(UserDetailsContext);

  const collapseToggle = onToggleCollapsed && (
    <IconButton
      onClick={onToggleCollapsed}
      title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
      aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
      size="small"
      sx={{
        display: { xs: "none", md: "inline-flex" },
        color: "var(--muted)",
        "&:hover": { color: "var(--text)" },
      }}
    >
      {collapsed ? (
        <ChevronRightIcon fontSize="small" />
      ) : (
        <ChevronLeftIcon fontSize="small" />
      )}
    </IconButton>
  );

  if (collapsed) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "6px",
        }}
      >
        {collapseToggle}
        <Link to="/my-tracks">
          <img
            style={{ width: "28px", height: "28px", objectFit: "contain" }}
            className="logo-image"
            src={isEnterprise ? ENTERPRISE_IMAGE_PATH : "/assets/images/logo-icon.png"}
            alt="logo"
          />
        </Link>
      </Box>
    );
  }

  return (
    <>
      {isEnterpriseAccount && (
        <Box sx={{ marginBottom: "10px" }}>
          <img
            style={{ width: "60px", height: "50px" }}
            src={enterprise?.image.includes("http") ? enterprise.image : photo}
            alt=""
          />
        </Box>
      )}
      <Box
        sx={
          isEnterpriseAccount
            ? {
                display: "flex",
                justifyContent: isEnterpriseAccount
                  ? "space-between"
                  : "flex-start",
                alignItems: "center",
                backgroundColor: "#1F242F",
                padding: "5px",
                borderRadius: "7px",
              }
            : styles.logoContainer
        }
      >
        {isEnterpriseAccount && (
          <Typography sx={{ fontWeight: "bold" }}>Powered by</Typography>
        )}
        <Link to="/my-tracks">
          <img
            style={{ width: "110px", height: "30px" }}
            className="logo-image"
            src={isEnterprise ? ENTERPRISE_IMAGE_PATH : logo}
            alt="logo"
          />
        </Link>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {collapseToggle}
          {isDrawerOpen && (
            <IconButton
              onClick={() => {
                if (setIsDrawerOpen) setIsDrawerOpen(false);
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
        </Box>
      </Box>
    </>
  );
};
